import { RemoteLoggerUseCase } from '../../remote-logger/remote-logger.use-case';
import { FeatureFlags } from './feature-flag.models';

const FEATURE_FLAG_TAG_PREFIX = 'featureFlag';

export function logFeatureFlags(featureFlags: FeatureFlags, remoteLogger: RemoteLoggerUseCase) {
  const featureFlagDefinedKeys = Object.keys(new FeatureFlags());

  Object.entries(featureFlags)
    .filter(([key]) => featureFlagDefinedKeys.includes(key))
    .forEach(([key, value]) => {
      remoteLogger.setTag(`${FEATURE_FLAG_TAG_PREFIX}.${key}`, value);
    });
}
